import React, { useState } from "react";
import { nanoid } from "nanoid";

export default function (props) {
  const sgNumberOptions = window.$units.map((item) => {
    return <option key={nanoid()}>{item}</option>;
  });
  return (
    <div className="ownerdetails">
      <label>SG Number</label>
      <select
        id="sg_numberes"
        name="sg_numbers"
        value={props.sgnumber}
        placeholder="Select Car Make"
        onChange={(event) => props.handleSgnumber(event)}
      >
        <option disabled={true} value="">
          Select SG Number
        </option>
        {sgNumberOptions}
      </select>
    </div>
  );
}
